import type { GameId, PublicRoomInfo } from '@pixelworld/shared';
import { useEffect, useState } from 'react';
import { fetchPublicRooms } from './rooms-api';

const REFRESH_MS = 5_000;

/** The public rooms of a game, refreshed every few seconds while the start page is open. */
export function usePublicRooms(gameId: GameId): PublicRoomInfo[] {
  const [rooms, setRooms] = useState<PublicRoomInfo[]>([]);

  useEffect(() => {
    let active = true;
    const load = async () => {
      const result = await fetchPublicRooms(gameId);
      // A failed refresh keeps the last list; the next one tries again.
      if (active && result.ok) setRooms(result.data.rooms);
    };
    void load();
    const timer = setInterval(() => void load(), REFRESH_MS);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [gameId]);

  return rooms;
}
